// extracted by mini-css-extract-plugin
export var btn = "z_r v_tp v_tb f_cz f_cP f_cD f_fw";
export var full = "z_vh f_bz f_bL";